import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { Item } from './Item';
import { TranslationLanguage } from './Translation';

export interface Summarization extends Item {
  language: TranslationLanguage;
  chapterId: number;
  summarizedText: string;
}

export const translateSummarizationForTransport = (attributes: any): any => {
  const { highlightText, summarizedText } = attributes;
  return {
    ...attributes,
    highlightText: !isBase64(highlightText) ? base64Encode(highlightText) : highlightText,
    summarizedText: !isBase64(summarizedText) ? base64Encode(summarizedText) : summarizedText,
  };
};

export const translateSummarizationFromTransport = (attributes: any): any => {
  const { highlightText, summarizedText } = attributes;
  return {
    ...attributes,
    highlightText: isBase64(highlightText) ? base64Decode(highlightText) : highlightText,
    summarizedText: isBase64(summarizedText) ? base64Decode(summarizedText) : summarizedText,
  };
};
